import { Alert, AlertTitle, Button, Typography } from '@mui/material';
import { ERROR_DEFINITIONS } from '@lsc/shared';
import { isApiError } from '../api/errors';

export interface ErrorAlertProps {
  error: unknown;
  title?: string;
  onRetry?: () => void;
}

/**
 * Shows a user-facing error message and – if available – the request ID as „Fehler-ID“ (§66).
 * Never renders stack traces or technical details (§53).
 */
export function ErrorAlert({ error, title, onRetry }: ErrorAlertProps) {
  const message = isApiError(error) ? error.message : ERROR_DEFINITIONS.INTERNAL_ERROR.message;
  const requestId = isApiError(error) ? error.requestId : null;
  return (
    <Alert
      severity="error"
      role="alert"
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            Erneut versuchen
          </Button>
        ) : undefined
      }
    >
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      {message}
      {requestId ? (
        <Typography variant="body2" component="p" sx={{ mt: 1, opacity: 0.85 }}>
          Fehler-ID: <code>{requestId}</code>
        </Typography>
      ) : null}
    </Alert>
  );
}
